import {
  Action,
  ActionType,
  ISchoolTypeResponse,
} from "models/classmanagement/schoolType";
import createReducer from "../../createReducer";

export interface SchoolTypeReducerType {
  loading: boolean;
  error?: string;
  schoolTypeResponse?: ISchoolTypeResponse;
}

const defaultState: SchoolTypeReducerType = {
  loading: false,
  error: undefined,
  schoolTypeResponse: undefined,
};

export const schoolTypeReducer = createReducer<SchoolTypeReducerType>(
  defaultState,
  {
    [ActionType.GET_SCHOOL_TYPE](state: SchoolTypeReducerType) {
      return {
        ...state,
        loading: true,
      };
    },

    [ActionType.GET_SCHOOL_TYPE_ERROR](
      state: SchoolTypeReducerType,
      action: Action<number>
    ) {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    },

    [ActionType.GET_SCHOOL_TYPE_SUCCESS](
      state: SchoolTypeReducerType,
      action: Action<number>
    ) {
      return {
        ...state,
        loading: false,
        error: null,
        schoolTypeResponse: action.payload,
      };
    },
  }
);
